<template>
  <div class="consumer-rights-home">
    <div class="home-content">
      <div class="logo-wrap">
        <img
          class="logo-img"
          referrerpolicy="no-referrer"
          src="https://common-h5-dev.xiangshuheika.com/static/upload/202606249eb2f6cd5de9.png"
          alt="消费者权益服务站"
        />
        <span class="logo-title">消费者权益服务站</span>
      </div>
      <button class="enter-btn" @click="openNotice">进入投诉</button>
      <p class="footer-text">
        深圳市市场监督管理局南山监管局<br />
        深圳市南山区消费者委员会<br />
        监制
      </p>
    </div>

    <NoticePopup
      ref="noticePopup"
      :visible="showNotice"
      @close="onNoticeClose"
      @confirm="onNoticeConfirm"
    />

    <ExitConfirmDialog
      :visible="showExitConfirm"
      @abandon="onAbandon"
      @continue="onContinue"
    />
  </div>
</template>

<script>
import NoticePopup from "./components/NoticePopup.vue";
import ExitConfirmDialog from "./components/ExitConfirmDialog.vue";
import { clearFormCache } from "./utils";

export default {
  name: "consumerRights",
  components: {
    NoticePopup,
    ExitConfirmDialog,
  },
  data() {
    return {
      showNotice: false,
      showExitConfirm: false,
    };
  },
  methods: {
    openNotice() {
      this.showNotice = true;
    },
    onNoticeClose() {
      this.showExitConfirm = true;
    },
    onNoticeConfirm() {
      this.showNotice = false;
      this.$router.push("/consumerRights/form");
    },
    onAbandon() {
      clearFormCache();
      this.showExitConfirm = false;
      this.showNotice = false;
    },
    onContinue() {
      this.showExitConfirm = false;
    },
  },
};
</script>

<style lang="less" scoped>
.consumer-rights-home {
  min-height: 100vh;
  background: #fff;
}

.home-content {
  overflow: hidden;
  padding-bottom: 47px;
  box-sizing: border-box;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.logo-wrap {
  width: 224px;
  margin: 115px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo-img {
  width: 157px;
  height: 157px;
}

.logo-title {
  margin-top: 16px;
  color: #60b160;
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  text-align: center;
}

.enter-btn {
  display: block;
  width: calc(100% - 67px);
  margin: 50px auto 0;
  padding: 10px 0;
  border: none;
  border-radius: 20px;
  background: #4fa4d3;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  cursor: pointer;
}

.footer-text {
  width: 180px;
  margin: auto auto 0;
  color: rgba(102, 102, 102, 0.6);
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}
</style>
